var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsOutFocus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C17.7 0 20.25 0.75 22.5 2.1C24.75 3.45 26.55 5.25 27.9 7.5C29.25 9.75 30 12.3 30 15C30 17.7 29.25 20.25 27.9 22.5C26.55 24.75 24.75 26.55 22.5 27.9C20.25 29.25 17.7 30 15 30C12.3 30 9.75 29.25 7.5 27.9C5.25 26.55 3.45 24.75 2.1 22.5C0.75 20.25 0 17.7 0 15C0 12.3 0.75 9.75 2.1 7.5C3.45 5.25 5.25 3.45 7.5 2.1C9.75 0.75 12.3 0 15 0ZM18.45 22.05V20.55C18.45 20.4 18.45 20.25 18.3 20.1C18.15 19.95 18 19.95 17.85 19.95H17.1V13.95C17.1 13.8 17.1 13.65 16.95 13.5C16.8 13.35 16.65 13.35 16.5 13.35H12.3C12.15 13.35 12 13.35 11.85 13.5C11.7 13.35 11.55 13.65 11.55 13.8V15.3C11.55 15.45 11.55 15.6 11.7 15.75C11.85 15.9 12 15.9 12.15 15.9H12.9V19.8H12.3C12.15 19.8 12 19.8 11.85 19.95C11.7 20.1 11.7 20.25 11.7 20.4V21.9C11.7 22.05 11.7 22.2 11.85 22.35C12 22.5 12.15 22.5 12.3 22.5H17.55C17.7 22.5 17.85 22.5 18 22.35C18.3 22.35 18.45 22.2 18.45 22.05ZM15 6.6C14.25 6.6 13.65 6.9 13.2 7.35C12.75 7.8 12.45 8.55 12.45 9.15C12.45 9.75 12.75 10.5 13.2 10.95C13.65 11.55 14.25 11.7 15 11.7C15.75 11.7 16.35 11.4 16.8 10.95C17.25 10.5 17.55 9.9 17.55 9.15C17.55 8.4 17.25 7.8 16.8 7.35C16.35 6.9 15.75 6.6 15 6.6Z",
    fill: "#808284"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsOutFocus);
export default __webpack_public_path__ + "static/media/settings-out-focus.a92ead34dbc006e03745a4efa498a8f4.svg";
export { ForwardRef as ReactComponent };